import { Fragment, useEffect, useState } from 'react';
import { Dialog, DialogBackdrop, DialogPanel, PopoverGroup, Menu, Transition, TabGroup, TabList, Tab, TabPanel, TabPanels, Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import { AdjustmentsHorizontalIcon, Bars3Icon, MagnifyingGlassIcon, XMarkIcon, UserIcon, ChevronDownIcon, ArrowRightEndOnRectangleIcon } from '@heroicons/react/24/outline';
import ShoppingCart from '../main_compos/ShoppingCart';
import { whiteTextLogo } from '../../assets/images/logos';
import LanguageSelector from '../../utils/LanguageSelector';
import { useTranslation } from 'react-i18next';
import { ArrowLeftStartOnRectangleIcon, Cog8ToothIcon, ShoppingBagIcon, UserCircleIcon } from '@heroicons/react/24/solid';
import Notify from '../../utils/useNotify';
import axios from 'axios';
import useConfirmation from '../../utils/useConfirmation';
import { useNavigate } from 'react-router';
import i18next from 'i18next';
import { truncateString } from '../../utils/truncateString';
import { fileNotFound, whatsappIcon } from '../../assets/images/icons';
import TopBar from './TopBar';

export default function Navigation() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [openM, setOpenM] = useState(false);
  const [categories, setCategories] = useState([]);
  const [megaMenu, setMegaMenu] = useState([]);
  const [role, setRole] = useState("");
  const [loading, setLoading] = useState(true);
  const localhost = process.env.REACT_APP_LOCALHOST;
  const localimg = process.env.REACT_APP_LOCALHOST_IMG;
  const username = localStorage.getItem('username');
  const token = localStorage.getItem('token');
  const { open, ConfirmComponent } = useConfirmation();
  const [categoriesVisible, setCategoriesVisible] = useState(false);
  const [siteLogo, setSiteLogo] = useState(null);

  const fetchSiteLogo = async () => {
    try {
      const res = await axios.get(`${localhost}site-settings`);
      if (res.data?.logo) setSiteLogo(localimg + res.data.logo);
    } catch (err) {
      // console.error(err);
    }
  };

  const fetchCategories = async () => {
    try {
      const resC = await axios.get(`${localhost}all-categories`);
      const data = resC.data;
      // console.log(data);
      setCategories(data);
    } catch (err) {
      // console.error(err);
    }
  };

  const fetchMegaMenu = async () => {
    try {
      const resProd = await axios.get(`${localhost}mega-menu`);
      const data = resProd.data;
      const updatedData = data.map(item => {
        const imgs = item.imgs ? JSON.parse(item.imgs) : null;
        return { ...item, imgs };
      });
      setMegaMenu(updatedData);
    } catch (err) {
      // console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchUser = async () => {
    if (token) {
      try {
        const resUser = await axios.get(`${localhost}user`, { headers: { 'Authorization': `Bearer ${token}` } });
        setRole(resUser.data.role);
      } catch (err) {
        navigate("/signin");
        localStorage.removeItem("session_id");
        localStorage.removeItem("token");
        localStorage.removeItem("username");
      }
    }
  };

  useEffect(() => {
    fetchSiteLogo();
    fetchCategories();
    fetchMegaMenu();
    if (token) {
      fetchUser();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const navLinks = [
    { name: 'home', href: '/' },
    { name: 'shop', href: '/shop' },
    { name: 'new-arrivals', href: '/new-arrivals' },
    // { name: 'about', href: '/about' },
  ];

  const menuItems = [
    role === "admin"
      ? [
        { label: 'dashboard', icon: AdjustmentsHorizontalIcon, href: '/admin' },
        { label: 'account', icon: UserCircleIcon, href: '/admin/settings' }
      ]
      : role === "customer"
        ? [
          { label: 'account', icon: UserCircleIcon, href: '/account/account-details' },
          { label: 'my-purchases', icon: ShoppingBagIcon, href: '/account/purchases' },
          { label: 'settings', icon: Cog8ToothIcon, href: '/account/dashboard' }
        ]
        : []
  ].flat();


  const handleLogout = async () => {
    try {
      await axios.post(localhost + 'logout', null, { headers: { 'Authorization': `Bearer ${token}` } });
      Notify("success", t("logout-msg"));
      setTimeout(() => {
        localStorage.removeItem("token");
        localStorage.removeItem("username");
        navigate("/signin");
      }, 500);
    } catch (err) {
      Notify("success", t("logout-msg"));
      setTimeout(() => {
        localStorage.removeItem("token");
        localStorage.removeItem("username");
        navigate("/signin");
      }, 500);
    }
  };

  const handleAction = () => {
    open(
      {
        title: t("logout-confirmation-header"),
        text: t("logout-confirmation-body"),
        action: "add",
      },
      handleLogout
    );
  };

  return (
    <div className="sticky top-0 z-40">
      {ConfirmComponent}
      {/* Mobile menu */}
      <Dialog open={openM} onClose={setOpenM} className="relative z-10 lg:hidden">
        <DialogBackdrop transition className="fixed inset-0 bg-black/25 transition-opacity duration-300 ease-linear data-[closed]:opacity-0" />

        <div className="fixed inset-0 z-10 flex">
          <DialogPanel transition className="relative flex w-full max-w-sm transform flex-col overflow-y-auto bg-black pb-12 shadow-xl transition duration-300 ease-in-out data-[closed]:-translate-x-full">
            <div className="flex px-4 pb-1 pt-3">
              <button type="button" onClick={() => setOpenM(false)} className="relative inline-flex items-center justify-center rounded-md p-1 text-white">
                <span className="absolute -inset-0.5" />
                <span className="sr-only">Close menu</span>
                <XMarkIcon className="size-7" />
              </button>
            </div>

            <div className="uppercase px-6 pt-2 pb-6 text-white">
              {navLinks.map((page, index) => (
                <div key={index} className="flow-root">
                  <a href={page.href} className="block py-2 font-medium">
                    {t(page.name)}
                  </a>
                </div>
              ))}

              {categories.map((page, index) => (
                <div key={index} className="flow-root">
                  <a href={`/shop?category=${page.id}`} className="block py-2 font-medium">
                    {page.name[i18next.language]}
                  </a>
                </div>
              ))}
            </div>

            <div className='pb-2 px-4'>
              <LanguageSelector screen="mobile" />
            </div>
          </DialogPanel>
        </div>
      </Dialog>

      <header className="relative">
        <TopBar t={t} />

        <nav aria-label="Top" className="bg-black text-white">
          <div className="mx-auto max-w-[1600px] px-4 sm:px-6 lg:px-8">
            <div className="flex h-16 items-center">
              <button type="button" onClick={() => setOpenM(true)} className="relative rounded-md p-2 text-white lg:hidden">
                <span className="absolute -inset-0.5" />
                <span className="sr-only">Open menu</span>
                <Bars3Icon className="size-6" />
              </button>

              {/* Logo */}
              <div className="ml-4 flex lg:ml-0">
                <a href="/">
                  <img loading="lazy" src={siteLogo || whiteTextLogo} className="h-7 w-auto" alt="logo" />
                </a>
              </div>

              {/* Flyout menus */}
              <PopoverGroup className="hidden lg:ml-8 lg:block lg:self-stretch">
                <div className="flex h-full space-x-8">
                  <Popover className="flex">
                    <div className="relative flex">
                      <PopoverButton className="relative z-10 -mb-px flex items-center border-b-2 border-transparent pt-px text-sm font-medium uppercase tracking-wide text-white/90 transition-colors duration-200 ease-out hover:text-white data-[open]:border-white data-[open]:text-white focus:outline-none">
                        {t("our-products")}
                      </PopoverButton>
                    </div>
                    <PopoverPanel transition className="absolute inset-x-0 top-full text-sm text-gray-500 transition data-[closed]:opacity-0 data-[enter]:duration-200 data-[leave]:duration-150 data-[enter]:ease-out data-[leave]:ease-in">
                      <div className="absolute inset-0 top-1/2 bg-white shadow" />
                      <div className="relative bg-white z-20">
                        <div className="mx-auto container px-8">
                          {
                            loading ? (
                              <div className="min-h-[45vh] flex items-center justify-center">
                                <div className="loading-spinner" />
                              </div>
                            ) : (
                              <div className="grid grid-cols-4 gap-x-8 gap-y-10 py-8">
                                <div className="col-start-2 col-span-3 grid grid-cols-3 gap-x-8">
                                  {megaMenu.map((item, index) => (
                                    <a href={`/product/${item.slug}`} key={index} className="group relative text-base sm:text-sm">
                                      <img loading="lazy" alt={item.name['en']} src={!item.imgs ? fileNotFound : localimg + item.imgs[0]} className="aspect-square w-full rounded-lg bg-gray-100 object-cover group-hover:opacity-75" />
                                      <a href={`/product/${item.slug}`} className="mt-2 block font-medium text-gray-900 truncate">
                                        <span className="absolute inset-0 z-10" />
                                        {item.name[i18next.language]}
                                      </a>
                                      <p className="mt-1">
                                        {t("shop-now")}
                                      </p>
                                    </a>
                                  ))}
                                </div>
                                <div className="row-start-1 text-sm">
                                  <div>
                                    <p className="font-medium text-gray-900">
                                      {t("categories")}
                                    </p>
                                    <ul role="list" className="mt-6 space-y-6 sm:mt-4 sm:space-y-4">
                                      <li className="flow-root">
                                        <a href={`/shop`} className="hover:text-gray-800">
                                          {t("all-categories")}
                                        </a>
                                      </li>
                                      {categories.map((item, index) => (
                                        <li key={index} className="flex">
                                          <a href={`/shop?category=${item.id}`} className="hover:text-gray-800">
                                            {item.name[i18next.language]}
                                          </a>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            )
                          }
                        </div>
                      </div>
                    </PopoverPanel>
                  </Popover>
                  {navLinks.map((page, index) => (
                    <a key={index} href={page.href} className="flex items-center text-sm font-medium uppercase tracking-wide text-white/90 hover:text-white">
                      {t(page.name)}
                    </a>
                  ))}
                </div>
              </PopoverGroup>

              <div className="ml-auto flex items-center">
                <div className="hidden lg:flex lg:flex-1 lg:items-center lg:justify-end lg:space-x-6">
                  {token ? (
                    <>
                      <Menu as="div" className="relative z-30">
                        <Menu.Button className="capitalize flex items-center gap-2 text-sm font-medium uppercase tracking-wide text-white/90 hover:text-white">
                          {username}
                          <ChevronDownIcon className="h-4 w-4" />
                        </Menu.Button>
                        <Transition
                          enter="transition duration-100 ease-out"
                          enterFrom="transform scale-95 opacity-0"
                          enterTo="transform scale-100 opacity-100"
                          leave="transition duration-75 ease-out"
                          leaveFrom="transform scale-100 opacity-100"
                          leaveTo="transform scale-95 opacity-0"
                        >
                          <Menu.Items className="absolute right-0 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5">
                            {menuItems.map((item) => (
                              <Menu.Item key={item.label} as="div">
                                {({ active }) => (
                                  <a href={item.href} className={`flex items-center px-4 py-2 text-sm ${active ? 'bg-gray-100' : ''}`} >
                                    <item.icon className="mr-3 h-5 w-5" />
                                    {t(item.label)}
                                  </a>
                                )}
                              </Menu.Item>
                            ))}

                            <Menu.Item as="div">
                              {({ active }) => (
                                <button type="button" onClick={handleAction} className={`flex items-center w-full px-4 py-2 text-sm ${active ? 'bg-gray-100' : ''}`} >
                                  <ArrowLeftStartOnRectangleIcon className="mr-3 h-5 w-5" />
                                  {t("logout")}
                                </button>
                              )}
                            </Menu.Item>
                          </Menu.Items>
                        </Transition>
                      </Menu>
                      <span className="h-6 w-px bg-white/20" />
                    </>
                  ) : (
                    <>
                      <a href="/signin" className="text-sm font-medium uppercase tracking-wide text-white/90 hover:text-white">
                        {t("signin")}
                      </a>
                      <span className="h-6 w-px bg-white/20" />
                      <a href="/signup" className="text-sm font-medium uppercase tracking-wide text-white/90 hover:text-white">
                        {t("signup")}
                      </a>
                    </>
                  )}
                </div>
                <LanguageSelector screen="desktop" />

                {/* Search */}
                <div className="flex lg:ml-6">
                  <a href="/search" className="p-2 text-white hover:text-white/80 rounded-full transition-colors duration-200 hover:bg-white/10">
                    <MagnifyingGlassIcon className="size-6" />
                  </a>
                </div>

                {/* ############################## User ############################## */}
                {token ? (
                  <div className="">
                    <Menu as="div" className="relative z-10 lg:hidden">
                      <Menu.Button className="capitalize flex w-full items-center gap-0 p-2 font-medium text-white hover:bg-white/10 rounded-md">
                        <UserIcon className="size-6" />
                        {/* <ChevronDownIcon className="size-4 -m-1" /> */}
                      </Menu.Button>
                      <Transition enter="transition duration-100 ease-out" enterFrom="transform scale-95 opacity-0" enterTo="transform scale-100 opacity-100" leave="transition duration-75 ease-out" leaveFrom="transform scale-100 opacity-100" leaveTo="transform scale-95 opacity-0" >
                        <Menu.Items className="absolute -right-4 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5">
                          <div className='capitalize px-4 py-1 border-b border-gray-200 text-center'>{username}</div>
                          {menuItems.map((item) => (
                            <Menu.Item key={item.label} as="div">
                              {({ active }) => (
                                <a href={item.href} className={`flex items-center px-4 py-2 text-sm ${active ? 'bg-gray-100' : ''}`} >
                                  <item.icon className="mr-3 h-5 w-5" />
                                  {t(item.label)}
                                </a>
                              )}
                            </Menu.Item>
                          ))}

                          <Menu.Item as="div">
                            {({ active }) => (
                              <button type="button" onClick={handleAction} className={`flex w-full items-center px-4 py-2 text-sm ${active ? 'bg-gray-100' : ''}`} >
                                <ArrowLeftStartOnRectangleIcon className="mr-3 h-5 w-5" />
                                {t("logout")}
                              </button>
                            )}
                          </Menu.Item>
                        </Menu.Items>
                      </Transition>
                    </Menu>

                  </div>
                ) : (
                  <div className="">
                    <a href="/signin" className="block lg:hidden p-2 text-white hover:text-white/80 rounded-full transition-colors duration-200 hover:bg-white/10">
                      <ArrowRightEndOnRectangleIcon className="size-6" />
                    </a>
                    {/* <a href="/signup" className="block p-2 font-medium text-gray-900 hover:bg-gray-50">
                      {t("signup")}
                    </a> */}
                  </div>
                  // <div className="space-y-6 border-t border-gray-200 px-4 py-2">
                  //   <a href="/signin" className="block p-2 font-medium text-gray-900 hover:bg-gray-50">
                  //     {t("signin")}
                  //   </a>
                  //   <a href="/signup" className="block p-2 font-medium text-gray-900 hover:bg-gray-50">
                  //     {t("signup")}
                  //   </a>
                  // </div>
                )}
                {/* ############################## User ############################## */}

                {/* Cart */}
                <div className="flow-root">
                  <ShoppingCart />
                </div>
              </div>
            </div>
          </div>
        </nav>
      </header>

      <button className="z-30 fixed bottom-6 right-6 p-0 rounded-full focus:outline-none">
        <a href="https://wa.me/212774804516" target="_blank" rel="noopener noreferrer">
          <img loading="lazy" src={whatsappIcon} alt="whatsapp" className='size-12' />
        </a>
      </button>
    </div>
  )
}
